import { ANIMATION_TYPE } from "./../ricos-content/index.js";
const pluginAnimationViewer = (config) => ({
  config: { type: "animation", ...config },
  type: ANIMATION_TYPE
});
export {
  pluginAnimationViewer
};
//# sourceMappingURL=viewer.js.map
